import service from '../service';

export interface RecurringInvoice {
  Data: {
    FileDataBlob: string;
  };
  Successful: boolean;
  message?: string;
}

export interface GetRecurringInvoiceParams {
  accountGuid: string;
  month?: number;
  year?: number;
}

const getRecurringInvoice = async (
  { accountGuid, month, year }: GetRecurringInvoiceParams,
  { accessToken }: { accessToken: string }
) => {
  const response = service.get<RecurringInvoice>(
    `/account/${accountGuid}/recurring-invoice`,
    {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        ...(month != null ? { month } : {}),
        ...(year != null ? { year } : {}),
      },
      timeout: 30000,
    }
  );
  return response;
};

export default getRecurringInvoice;
